import React from 'react';
import { valueAtPercent, percentAtValue } from './StackGraph';

const StackGraphSettings = ({ sliders, values, open, onToggle, onChange, onReset }) => (
  <div className={`stack-graph-settings${open ? ' stack-graph-settings--open' : ''}`}>
    <button
      type="button"
      className="stack-graph-settings-toggle"
      aria-label="Graph settings"
      aria-expanded={open}
      onClick={onToggle}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
      </svg>
    </button>

    {open && (
      <div className="stack-graph-settings-panel">
        {sliders.map((s) => {
          const curve = s.curve || 1;
          // The range input's own position is in percent-space (0-100), not raw
          // value — since curve != 1 for spring/repulsion, an evenly-spaced drag
          // along the track needs to map through the same curve as the display
          // percent, or the handle's position would silently disagree with the
          // "%" readout next to it.
          const pct = Math.round(percentAtValue(s.min, s.max, values[s.key], curve));
          const handlePercentChange = (nextPct) => {
            const clamped = Math.min(100, Math.max(0, nextPct));
            onChange(s.key, valueAtPercent(s.min, s.max, clamped, curve));
          };
          return (
            <div className="stack-graph-slider-row" key={s.key}>
              <span className="stack-graph-slider-label">{s.label}</span>
              <div className="stack-graph-slider-controls">
                <input
                  type="range"
                  min={0}
                  max={100}
                  step={1}
                  value={pct}
                  onChange={(e) => handlePercentChange(Number(e.target.value))}
                />
                <div className="stack-graph-slider-percent">
                  <input
                    type="number"
                    min={0}
                    max={100}
                    value={pct}
                    onChange={(e) => handlePercentChange(Number(e.target.value))}
                  />
                  <span>%</span>
                </div>
              </div>
            </div>
          );
        })}
        <button type="button" className="stack-graph-settings-reset" onClick={onReset}>
          Reset
        </button>
      </div>
    )}
  </div>
);

export default StackGraphSettings;
